import { useState } from 'react'
import { array, func } from 'prop-types';
import { AdvancedSearch, InputWithEnterEvent } from '../'
import Select from '../Select'

const AutoFilters = (props) => {
    const onSearch = () => {
        props.onSearch(Object.keys(inputs).map(key => ({ field: key, value: inputs[key] })).filter(filter => filter.value !== ''))
        
        const newLabels = []
        props.schema.forEach(filter => {
            const input = inputs[filter.field]
            if (input !== '')
                newLabels.push({
                    title: filter.title,
                    value: filter.formatLabel ? filter.formatLabel(input) : input
                })
        })
        setLabels(newLabels)
    }

    const [inputs, setInputs] = useState(props.schema.reduce((obj, filter) => ({...obj, [filter.field]: '' }), {}))
    const [labels, setLabels] = useState([])

    const inputSection = props.schema.map(filter => (
        <div className="col-12 col-md-6 col-lg-4" key={filter.field}>
            <label htmlFor="codigo" className="form-label">{filter.title}</label>
            {filter.type === 'list' ? (
                <Select
                    name={filter.field}
                    className="form-control"
                    value={inputs[filter.field]}
                    placeholder="Todos"
                    onChange={({ target: { value }}) => setInputs(prev => ({ ...prev, [filter.field]: value }))}
                    options={filter.options.map(option => ({ value: String(option.value), label: option.label }))}
                    emptyOption="Todos"
                    emptyValue=""
                />
            ) : (
                <InputWithEnterEvent
                    name="codigo"
                    type="text"
                    placeholder=""
                    className="form-control"
                    value={inputs[filter.field]}
                    onEnter={onSearch}
                    onChange={({ target: { value } }) => setInputs(prev => ({ ...prev, [filter.field]: value }))}
                />
            )}
        </div>
    ))

    return (
        <AdvancedSearch {...{labels, onSearch}} >
            <div className='row form-basic'>
                {inputSection}
            </div>
        </AdvancedSearch>
    )
}

AutoFilters.propTypes = {
    onSearch: func.isRequired,
    schema: array.isRequired,
}

export default AutoFilters
